export default __webpack_public_path__ + "static/media/Auth0.ab52de8e.png";